exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#main-bandaid[data-v-7cd8ccb0]{float:right}.bandaid-sign[data-v-7cd8ccb0]{text-decoration:none}.bandaid-sign-neg[data-v-7cd8ccb0],.bandaid-sign[data-v-7cd8ccb0]{line-height:normal;display:inline;font-size:1.5em;color:#0d6496!important}.bandaid-sign-neg[data-v-7cd8ccb0]{float:left;margin-left:.5em;text-decoration:none!important}.bandaid-sign-plus[data-v-7cd8ccb0]{line-height:normal;display:inline;float:right;margin-right:.5em;font-size:1.5em;color:#0d6496!important}.bandaid-sign-neg[data-v-7cd8ccb0]:hover,.bandaid-sign-plus[data-v-7cd8ccb0]:hover{font-weight:900}#bandaid-amount[data-v-7cd8ccb0]{color:#0d6496!important;font-weight:600;display:inline}#bandaid[data-v-7cd8ccb0]{border-radius:25px;border:1px solid #0d6496!important;color:#0d6496!important;width:5em;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cd8ccb0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/BandAid.vue
// module id = 460
// module chunks = 0